import {
  getAnchorsList,
  scrollToHashFromUrl,
  setAnchorToCurrentPage,
  setSectionIdToExternalAnchor,
} from './utils';

export default () => {
  scrollToHashFromUrl();

  const { currentPageAnchors, externalPageAnchors } = getAnchorsList();

  setSectionIdToExternalAnchor(externalPageAnchors);
  setAnchorToCurrentPage(currentPageAnchors);
};
